<div class="instances-container">
    <mat-card class="dashboard__menu">
        <mat-card-content class="instances" style="padding-top: 5px !important">
            <mat-list class="instances-list">
                <mat-list-item class="instances__item">
                    <div class="list-item-container">
                        <app-selected-indicator [isSelected]="false"></app-selected-indicator>
                        <span class="totals-item" routerLink="/instances">Instances</span>
                    </div>
                </mat-list-item>
                <mat-list-item class="instances__item">
                    <div class="list-item-container">
                        <app-selected-indicator [isSelected]="isOpened('maintenance')"></app-selected-indicator>
                        <span class="totals-item" [routerLink]="['maintenance']">Maintenance</span>
                    </div>
                </mat-list-item>
                <mat-list-item class="instances__item">
                    <div class="list-item-container">
                        <app-selected-indicator [isSelected]="isOpened('system-events')"></app-selected-indicator>
                        <span class="totals-item" [routerLink]="['system-events']">System Events</span>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-card-content>
    </mat-card>
</div>

<mat-divider [vertical]="true"></mat-divider>

<router-outlet></router-outlet>